import { StyleSheet } from 'react-native-web';
import tinycolor from 'tinycolor2';
import { colors } from '../../constants';

const minimumNotMetColor = colors.no;
const suggestedNotMetColor = colors.maybe;
const checksPassedColor = colors.yes;

export default StyleSheet.create({
  container: {
    marginVertical: 15,
    height: 100,
    borderRadius: 10,
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
  },
  gameMessage: {
    fontWeight: 'bold',
    fontSize: 10,
    lineHeight: 21,
  },
  minimumNotMet: {
    borderColor: minimumNotMetColor,
    backgroundColor: tinycolor(minimumNotMetColor).lighten(35).toRgbString(),
  },
  suggestedNotMet: {
    borderColor: suggestedNotMetColor,
    backgroundColor: tinycolor(suggestedNotMetColor).lighten(35).toRgbString(),
  },
  checksPassed: {
    borderColor: checksPassedColor,
    backgroundColor: tinycolor(checksPassedColor).lighten(35).toRgbString(),
  },
  infoLink: {
    fontSize: 10,
    textAlign: 'center',
    cursor: 'pointer',
    color: colors.lightBlue,
    marginBottom: 15,
    fontWeight: 'normal',
  },
});
